import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import "./style.scss";
import ContactButton from "../../buttnos";
import { useNavigate } from "react-router-dom";
import { useFormSelection } from "../../../context/formContext";
import { api } from "../../../helpers";
import { serviceImageUrl } from "../../../helpers/serviceContent";

const MobileServicesAccordion = ({ services, onSelect }) => {
  const navigate = useNavigate();
  const { setSelectedService } = useFormSelection();
  const list = Array.isArray(services) && services.length > 0 ? services : [];

  const handleLearnMore = (svcType) => {
    setSelectedService(svcType);
    navigate("/services", { state: { scrollTo: "service-slider" } });
  };

  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <div className="mobile-services">
      <h2 className="mobile-services__title">Our Services</h2>
      {list.map((service, index) => (
        <div className="accordion" key={service._id ?? service.type ?? index}>
          <div
            className={`accordion__header ${
              openIndex === index ? "active" : ""
            }`}
            onClick={() => {
              toggle(index);
              onSelect(index);
            }}
          >
            <span>{service.title}</span>
            {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
          </div>
          {openIndex === index && (
            <div className="accordion__content">
              <p>{service.subtitle ?? service.description ?? ""}</p>
              {service.image ? (
                <img
                  src={serviceImageUrl(api, service.image)}
                  alt={service.title}
                />
              ) : null}
              <ContactButton
                text="Learn More"
                btnclass="more-btn"
                onSubmit={() => handleLearnMore(service.type)}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MobileServicesAccordion;
